import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";
import ImpfImage from "../../images/leistungen/impfen.jpg"

import Claudia1 from "../../images/leistungen/WEB-HerzdoktorSebald2026-015.jpg"
import Claudia2 from "../../images/leistungen/WEB-HerzdoktorSebald2026-016.jpg"

const Impfen = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Impfberatung </h1>
                    

                    <p className="page-text">
                        Es ist mir ein besonderes Anliegen, Ihnen hier Information bezüglich empfohlener Impfungen für Erwachsene zukommen zu lassen.Derzeit besteht eine viel zu geringe Durchimpfungsrate in der Erwachsenenbevölkerung.
                        <br />Kommen Sie mit Ihrem Impfpass, bzw. wir stellen einen neuen aus.
                    </p>

                    <div className="claudia-images">
                    <img src={ImpfImage}/>
                        <img src={Claudia1} alt="Claudia – Herzdoktor Sebald" />
                        <img src={Claudia2} alt="Claudia – Herzdoktor Sebald" />
                    </div>

                    <h3> Aktuell </h3>
                    <p className="page-text"> Unsere <b>aktuellen Angebote zum Thema Impfen:</b> </p>
                    <ul>
                        <li> Influenza </li>
                        <li> Keuchhusten -Pertussis </li>
                        <li> Pneumokokken </li>
                    </ul>
                    <p className="page-text"> 
                        <br/><b>Falls Sie Fragen zur Covid Impfung haben</b>, wenden Sie sich bitte an: <a href="https://impfservice.wien/">Informationen zur Corona-Schutzimpfung - Impfservice Wien.</a>
                        <br/><br/>Impfcheck! Wann haben Sie das letzte mal Ihre Impfungen aufgefrischt?
                        <br/><br/> <b> Auch im Erwachsenenalter muss regelmässig aufgefrischt werden! </b>
                    </p>
                    <h3> Impfempfehlung für (gesunde) Erwachsene </h3>
                    <table style={{ borderCollapse: "collapse", width: "100%", "textAlign":"center"}} border="1" cellPadding="8">
                        <thead>
                            <tr>
                                <th>Alter</th>
                                <th>18–49 LJ.</th>
                                <th>50–59 LJ.</th>
                                <th>60–64 LJ.</th>
                                <th>über 64 LJ.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Influenza</td>
                                <td colSpan="4"> jährlich auffrischen</td>
                            </tr>
                            <tr>
                                <td>RSV</td>
                                <td colSpan="2"></td>
                                <td colSpan="2">einmalig</td>
                            </tr>
                            <tr>
                                <td>Pneumokokken</td>
                                <td colSpan="2"></td>
                                <td colSpan="2">
                                <strong>JETZT NEU!! Capvaxive</strong><br />
                                1x Impfung
                                </td>
                            </tr>
                            <tr>
                                <td>Herpes zoster</td>
                                <td colSpan="2"></td>
                                <td colSpan="2">2 Impfungen, die zweite nach 2–6 Monaten</td>
                            </tr>
                            <tr>
                                <td>Covid 19</td>
                                <td colSpan="2"></td>
                                <td colSpan="2">jährlich auffrischen</td>
                            </tr>
                            <tr>
                                <td>Tetanus / Diphterie / Polio</td>
                                <td colSpan="2">alle 5 Jahre auffrischen</td>
                                <td colSpan="2">alle 5 Jahre auffrischen</td>
                            </tr>
                            <tr>
                                <td>FSME</td>
                                <td colSpan="2">alle 5 Jahre auffrischen</td>
                                <td colSpan="2">alle 3 Jahre auffrischen</td>
                            </tr>
                            <tr>
                                <td colSpan="5"> Quelle Impfplan Österreich,<a href="https://www.sozialministerium.gv.at/"> sozialministerium.at</a> </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        Nähere Information finden Sie im aktuellen Österreichischer Impfplan unter:
                        <a href="https://www.sozialministerium.gv.at/impfplan"> Impfplan_Oesterreich_2024-2025.pdf</a>
                        Weitere Imformationen zum Thema impfen:
                        <a href="https://www.impfenschuetzt.at"> https://www.impfenschuetzt.at</a> - eine Information der Österreichischen Kardiologischen Gesellschaft
                        Zum <a href="https://impfservice.wien/">Impfservice Wien</a>
                    </p>

                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Impfen;
